<h1 bitTypography="h1" class="tw-mt-16 tw-pb-2.5 !tw-text-danger">{{ "dangerZone" | i18n }}</h1>

<div class="tw-rounded tw-border tw-border-solid tw-border-danger-600 tw-p-5">
  <div
    #content
    class="tw-grid tw-auto-rows-fr @2xl:tw-grid-cols-2 @3xl:tw-flex tw-gap-2 @2xl:tw-gap-4 @3xl:tw-gap-2"
  >
    <ng-content></ng-content>
  </div>
</div>
